// extracted by mini-css-extract-plugin
module.exports = {"pointer":"titleBar_pointer__2h-7w","title-bar":"titleBar_title-bar__3W5uP","first":"titleBar_first__PIBdf","last":"titleBar_last__2vQ77","middle":"titleBar_middle__220jH"};